import {
  ASSET_TYPE_CAMERA,
  ASSET_TYPE_CAMERA_TAG,
  ASSET_TYPE_CONTAINER,
  ASSET_TYPE_PHONE,
  ASSET_TYPE_VEHICLE,
} from '../constants/asset';
import { Asset, AssetMinimal, AssetType, VehicleLikeType } from '../types/asset';

export const getAssetTitle = (
  asset: Asset | AssetMinimal,
  showContainerIdent = false,
  onlyContainerIdent = false,
  returnString = '-'
) => {
  let title = returnString;
  if (asset.assetType === ASSET_TYPE_VEHICLE) {
    if (asset.vehicle?.brand && asset.vehicle?.subBrand) {
      title = `${asset.vehicle?.brand.name} ${asset.vehicle?.subBrand.name}, ${asset.vehicle?.licensePlate}`.trim();
    } else {
      title = asset.vehicle?.licensePlate ?? '-';
    }
  } else if (asset.assetType === ASSET_TYPE_CONTAINER && asset.container?.identifier) {
    if (onlyContainerIdent) {
      title = asset.container.identifier;
    } else {
      title = 'Contenedor';
      if (showContainerIdent) title += ` - ${asset.container.identifier}`;
    }
  }
  return title;
};

export function isArrayOfAssets(assets: any[]): assets is Asset[] {
  return !!(assets[0] as Asset)?._id;
}

export function assetTypeDataTitle(assetType: AssetType): string {
  if (assetType === ASSET_TYPE_PHONE) return '';
  if (assetType === ASSET_TYPE_CONTAINER) {
    return 'Datos del Contenedor';
  }
  return 'Datos del Vehículo' + (assetType === ASSET_TYPE_CAMERA ? ` ${ASSET_TYPE_CAMERA_TAG}` : '');
}

export function requireAssetData(assetType: string = ''): boolean {
  return assetType === ASSET_TYPE_CONTAINER || assetType === ASSET_TYPE_VEHICLE || assetType === ASSET_TYPE_CAMERA;
}

export function isVehicleLikeType(assetType: string = ''): assetType is VehicleLikeType {
  return assetType === ASSET_TYPE_VEHICLE || assetType === ASSET_TYPE_CAMERA;
}
